import { format } from 'date-fns'

import { toLocaleString } from './strings'

const diaSemanas = [
  { value: 1, label: 'Segunda-feira' },
  { value: 2, label: 'Terça-feira' },
  { value: 3, label: 'Quarta-feira' },
  { value: 4, label: 'Quinta-feira' },
  { value: 5, label: 'Sexta-feira' },
  { value: 6, label: 'Sábado' },
  { value: 7, label: 'Domingo' }
]

// Método para buscar o label pelo valor
function getLabelByValue(value: number) {
  const dia = diaSemanas.find(d => d.value === value)
  return dia ? dia.label : 'Valor inválido'
}

const IsNullValues = (data: any) => {
  if (data != null) {
    return data
  } else {
    return ''
  }
}
export const parseParametrizatioCurveWeightData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'curva-nome': item.curva,
      'peso-loja': item.pesoCurvaLoja,
      'peso-empresa': item.pesoCurvaEmpresa,
      'peso-volume': item.pesoCurvaVolume,
      'peso-curva': item.pesoCurva,
      'corte-inicial': item.corteInicial,
      'corte-final': item.corteFinal
    })
  }

  return res
}

export const parseReabTypeVeichule = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'veic-nome': item.nome,
      'veic-peso': item.pesoMaximo,
      'veic-custo': toLocaleString(item.custoFixo)
    })
  }

  return res
}

export const parseReabRoutes = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.idRotaFormatado,
      'rota-veiculo': item.tipoVeiculoNome,
      'rota-type': item.setorId === 1 ? 'Ferragem' : 'Chaparia',
      'rota-agrupar': item.agrupar === true ? 'SIM' : 'NÃO',
      'rota-loja-id': item.lojaDesc,
      'rota-cd': item.centroDistribuicaoId + '-' + item.centroDistribuicaoNome,
      'rota-peso': item.cargaEspecial,
      'rota-dia': item.diaDaSemanaDesc
    })
  }

  return res
}
export const parseReabRoutesExport = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.idRotaFormatado,
      'rota-veiculo': item.tipoVeiculoNome,
      'rota-type': item.setorId === 1 ? 'Ferragem' : 'Chaparia',
      'rota-agrupar': item.agrupar === true ? 'SIM' : 'NÃO',
      'rota-loja-id': item.lojaId + ' - ' + item.lojaNome,
      'rota-cd': item.centroDistribuicaoId + '-' + item.centroDistribuicaoNome,
      'rota-peso': item.cargaEspecial,
      'rota-dia': getLabelByValue(item.diaDaSemana)
    })
  }

  return res
}

export const parseParametrizatioCurveExecutationData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'curva-executado': item.executado === 0 ? 'Nao Executado' : 'Executado',
      'curva-data': format(new Date(item.data), 'dd/MM/yyyy')
    })
  }

  return res
}

export const parseParametrizatioReabCronogramaExport = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'cron-1': item.tipoCronograma === 1 ? 'Default' : 'Especial',
      'cron-2': item.centroDistribuicaoId,
      'cron-3': getLabelByValue(item.diaDaSemana),
      'cron-4': item.setorId === 1 ? 'Ferragem' : 'Chaparia',
      'cron-5':
        item.previsaoEntrega.length > 0
          ? 'Entrega: ' +
            item.previsaoEntrega
              .map(
                (entrega: {
                  centroDistribuicaoId: any
                  previsaoEntrega: any
                }) =>
                  `${entrega.centroDistribuicaoId} - ${entrega.previsaoEntrega}`
              )
              .join(' | ')
          : '',
      'cron-6': item.ativo ? 'SIM' : 'Não',
      'cron-7': item.lojaId
    })
  }

  return res
}

export const parseParametrizatioDepedentsCDData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'loja-id': item.idLoja,
      'loja-descricao': item.lojaDescricao,
      'cd-id': item.idCentroDistribuicao,
      'cd-descricao': item.centroDistribuicaoDescricao
    })
  }

  return res
}

export const parseParametrizatioCurveStoreData = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'loja-id': IsNullValues(item.lojaId),
      'loja-desc': IsNullValues(item.lojaDescricao),
      'produto-id': IsNullValues(item.produtoId),
      'produto-desc': IsNullValues(item.produtoDescricao),
      'date-init': IsNullValues(
        format(new Date(item.dataInicio), 'dd/MM/yyyy')
      ),
      'date-end': IsNullValues(format(new Date(item.dataFim), 'dd/MM/yyyy')),
      'config-nome': IsNullValues(item.usuario),
      'criado-em': IsNullValues(format(new Date(item.criadoEm), 'dd/MM/yyyy')),
      'date-next': IsNullValues(
        format(new Date(item.dataProximaAtualizacao), 'dd/MM/yyyy')
      )
    })
  }

  return res
}
